export class NotificationAudioManager {
  constructor(props, i18n, attentionAudio = null, roomMusic = null) {
    this.i18n = i18n;
    this.attentionAudio = attentionAudio;
    this.roomMusic = roomMusic;
    this.defaultLanguage = props.siteSettings&&props.siteSettings.defaultRoomLanguage;

    this.audioMap = {
      en: {
        tevilah: [],
        bedikah: [],
        lockDoor: null,
        lockDoorAgain: null,
        nextTevilah: null,
        nextBedikah: null,
      },
      yi: {
        tevilah: [],
        bedikah: [],
        lockDoor: null,
        lockDoorAgain: null,
        nextTevilah: null,
        nextBedikah: null,
      },
    };

    const langAudio = this.audioMap.en;
    const yiAudio = this.audioMap.yi;

    for (let i = 2; i <= 11; i++) {
      if (props[`EnglishTevilah${i}Audio`]) {
        langAudio.tevilah[i] = new Audio(props[`EnglishTevilah${i}Audio`]);
      }
      if (props[`EnglishBedikah${i}Audio`]) {
        langAudio.bedikah[i] = new Audio(props[`EnglishBedikah${i}Audio`]);
      }
      if (props[`YiddishTevilah${i}Audio`]) {
        yiAudio.tevilah[i] = new Audio(props[`YiddishTevilah${i}Audio`]);
      }
      if (props[`YiddishBedikah${i}Audio`]) {
        yiAudio.bedikah[i] = new Audio(props[`YiddishBedikah${i}Audio`]);
      }
    }

    if (props.EnglishTevilahNextAudio) {
      langAudio.nextTevilah = new Audio(props.EnglishTevilahNextAudio);
    }
    if (props.EnglishBedikahNextAudio) {
      langAudio.nextBedikah = new Audio(props.EnglishBedikahNextAudio);
    }
    if (props.EnglishLockDoorAudio) {
      langAudio.lockDoor = new Audio(props.EnglishLockDoorAudio);
    }
    if (props.EnglishLockDoorAgainAudio) {
      langAudio.lockDoorAgain = new Audio(props.EnglishLockDoorAgainAudio);
    }
    if (props.EnglishWrongRoomAudio) {
      langAudio.wrongRoom = new Audio(props.EnglishWrongRoomAudio);
    }
    if (props.EnglishGreetingRoomAudio) {
      langAudio.greeting = new Audio(props.EnglishGreetingRoomAudio);
    }
    if (props.EnglishGoodbyeRoomAudio) {
      langAudio.goodbye = new Audio(props.EnglishGoodbyeRoomAudio);
    }
    if (props.YiddishTevilahNextAudio) {
      yiAudio.nextTevilah = new Audio(props.YiddishTevilahNextAudio);
    }
    if (props.YiddishBedikahNextAudio) {
      yiAudio.nextBedikah = new Audio(props.YiddishBedikahNextAudio);
    }
    if (props.YiddishLockDoorAudio) {
      yiAudio.lockDoor = new Audio(props.YiddishLockDoorAudio);
    }
    if (props.YiddishLockDoorAgainAudio) {
      yiAudio.lockDoorAgain = new Audio(props.YiddishLockDoorAgainAudio);
    }
    if (props.YiddishWrongRoomAudio) {
      yiAudio.wrongRoom = new Audio(props.YiddishWrongRoomAudio);
    }
    if (props.YiddishGreetingRoomAudio) {
      yiAudio.greeting = new Audio(props.YiddishGreetingRoomAudio);
    }
    if (props.YiddishGoodbyeRoomAudio) {
      yiAudio.goodbye = new Audio(props.YiddishGoodbyeRoomAudio);
    }
  }

  setRoomMusic(newAudio) {
    this.roomMusic = newAudio;
  }

  playNotification({ type, index, next = false, lockDoor = false, lockDoorAgain = false, wrongRoom = false, greeting = false, goodbye = false }) {
    const lang = this.audioMap[this.i18n.language] ? this.i18n.language : this.defaultLanguage;
    const langAudio = this.audioMap[lang] || this.audioMap[this.defaultLanguage] || {};
    let sound;

    if (next) {
      sound = (type&&langAudio[type === 'tevilah' ? 'nextTevilah' : 'nextBedikah']) || this.attentionAudio;
    } else if (lockDoor) {
      sound = langAudio.lockDoor || this.attentionAudio;
    } else if (lockDoorAgain) {
      sound = langAudio.lockDoorAgain || this.attentionAudio;
    } else if (wrongRoom) {
      sound = langAudio.wrongRoom || this.attentionAudio;
    } else if (greeting) {
      sound = langAudio.greeting;
    } else if (goodbye) {
      sound = langAudio.goodbye;
    } else if (index >= 1 && index <= 10) {
      sound = (langAudio[type] && langAudio[type][index+1]) || this.attentionAudio;
    }

    let initialRoomMusicPlaying = false;
    if (sound&&this.roomMusic&&!this.roomMusic.paused){
      initialRoomMusicPlaying = true;
      this.roomMusic.pause();
    } 

    if (this.currentSound) {
      this.currentSound.pause();
      this.currentSound.currentTime = 0;
    }
    
    if (sound) {
      sound.pause();
      const duration = sound.duration * 1000;
      setTimeout(() => {this.currentSound = sound;sound.play()}, 500);
      if (this.roomMusic&&initialRoomMusicPlaying) {
        setTimeout(() => this.roomMusic.play(), duration + 1000);
      }
    }
  }
}